module.exports = __webpack_public_path__ + "static/img/service_illustration_01_zh.4b661e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_illustration_01_zh.png
// module id = flm4
// module chunks = 34